import { render } from "./CustomAlerts.vue?vue&type=template&id=881be050"
import script from "./CustomAlerts.vue?vue&type=script&lang=js"
export * from "./CustomAlerts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__